import { render, staticRenderFns } from "./MaintenanceTemplatesView.vue?vue&type=template&id=dde522a4&scoped=true"
import script from "./MaintenanceTemplatesView.ts?vue&type=script&lang=ts&external"
export * from "./MaintenanceTemplatesView.ts?vue&type=script&lang=ts&external"
import style0 from "./MaintenanceTemplatesView.vue?vue&type=style&index=0&id=dde522a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde522a4",
  null
  
)

export default component.exports